import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.css']
})
export class RefundComponent implements OnInit {

  refundColl:any=[];

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport:boolean=false; 
  
  isloading:boolean=false;
  isprivilage:boolean=false;  
  showProgress:boolean=false;
  formname:String="Refund";

  filterby:String="PENDINGREFUND";
  isselectlist:boolean=false;


  fireshipment: any=[];


  
 searchtxt: any = "";
 columnDefs = [
  { headerName: 'RefundNo', field: 'refundno' },
  { headerName: 'OrderNo', field: 'orderno' },
  { headerName: 'EntryDate', field: 'createdon' },
  { headerName: 'Customer', field: 'firstname' },
  { headerName: 'Mode', field: 'refundcode' },
  { headerName: 'Paymode', field: 'paymode' },
  { headerName: 'RefundAmount', field: 'refundamt' },
  { headerName: 'Status', field: 'refundno' },
  { headerName: 'RefundPaymode', field: 'refundpaymode' },
 ]
 gridOptions = {
   enableactioncol: true,
   columnDefs: this.columnDefs,
   pageindex: 1
 };
 
 
 constructor( private appService: DhukanDataService,public router: Router,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private loginService:LoginDataService,
    private productFindService: NgbModal)
     {  this.fnServiceChanges(); }

     //User Check
    fnServiceChanges(){
      this.loginService.serviceloginChange.subscribe((value) => {
            if(this.loginService.fnCheckUser()){                
                this.fnCheckPrivilage();
                if(this.isview){
                  this.isloading=true;
                  this.fnOnInitForm();
                }
                else{
                  this.fnUserFailedForm();
                }    
            }
            else{
              this.fnUserFailedForm();
            }
      });

    }
  
   
 


  ngOnInit() {
    try{
     
      
     
      if(this.loginService.fnCheckUser()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
       this.loginService.fnGetUserRoleList();          
      }

    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){  
    this.fngetRefundView();     
  }

  fnCheckPrivilage(){
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport=this.loginService.fnCheckUserRoleAction(this.formname,'EXPORT');
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }
  

  ngAfterViewInit(): void {
   
  }

  ngOnDestroy(): void {
  
  }
  
  
  //Grid


  fnActionEditClick(data) {

    if (!this.isedit) {
      return;
    }

    this.fnEditRefund(data.refundid);
  }

  fnActionExportClick() {
 
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.refundColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }


  fngetRefundView() {   
    if(this.showProgress){
      return;
    }
    this.isselectlist=false;
    this.fnShowProgress();
      var data = {
        filterby:this.filterby,
        modifiedby:this.loginService.fnGetModUserId(), 
      }
      this.appService.getRefundByListview(data)
          .subscribe(
            (res)=>{           
              this.fnHideProgress();       
              if(res.json().status==200){                          
                this.refundColl=res.json().result;
                this.fnSetDataTable();

              }
              else if(res.json().status==400){                          
                this.toastr.error('Error', res.json().err_field);
              }                          
          },
            (err)=>{          
              this.fnHideProgress();       
              this.toastr.error('Error', err);
            })
  }


  fnAddRefund(){
    try{
        
  
      this.router.navigate(['/AddRefund']);
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

 
 
  fnEditRefund(orderid){
    try{
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'id': orderid,            
          }
        }
  
      this.router.navigate(['/AddRefund'], navigationExtras);
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  private fnSetDataTable(){
    
  }


  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }
  
  private fnShowProgress(){
    this.showProgress=true;
  }
  private fnHideProgress(){
    this.showProgress=false;
  }
  

  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }







}
